import UserGroupHierarchyContainer from '@src/components/usergroup/hierarchy/UserGroupHierarchyContainer';
import AppConfigService from '@src/service/common/AppConfigService';
import React from 'react';
const USER_GROUP_ROUTE = AppConfigService.getValue('components.userGroups.userGroupRouterProp');

const UserGroupHierarchyPage = () => <UserGroupHierarchyContainer basePath={USER_GROUP_ROUTE} />;

export default UserGroupHierarchyPage as any;
